import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { INVOICES_GET_ONE, INVOICES_GET_MANY } from 'api/query-keys';
import type { IInvoiceSyncStatusUpdateEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleInvoiceSyncUpdateStatus = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: IInvoiceSyncStatusUpdateEvent) => {
      const tripId = event.payload.invoiceId;

      await queryClient.invalidateQueries([INVOICES_GET_ONE, tripId]);
      await queryClient.invalidateQueries([INVOICES_GET_MANY]);
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.invoiceSyncStatusUpdated, handler);

    return () => {
      socket.removeListener(ESocketEventName.invoiceSyncStatusUpdated, handler);
    };
  }, [handler, socket]);
};
